import { render, staticRenderFns } from "./Sorters.vue?vue&type=template&id=8c0a65f2"
import script from "./Sorters.vue?vue&type=script&lang=js"
export * from "./Sorters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports